import type { JSX } from 'react'

import styles from './MockedRibbon.module.css'

/**
 * Diagonal ribbon overlay for avatars showing synthetic Mocktail data. Position a
 * `position: relative` wrapper around the avatar and drop this in as a sibling.
 */
export function MockedRibbon(): JSX.Element {
  return <span className={styles.ribbon}>Mocked</span>
}
